"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenReferralWidget = void 0;
var next_intl_1 = require("next-intl");
var useOpenReferralWidget = function () {
    var lang = (0, next_intl_1.useLocale)();
    return function () {
        var _a;
        var ReferralWindow = window;
        (_a = ReferralWindow === null || ReferralWindow === void 0 ? void 0 : ReferralWindow.call_refer_friend) === null || _a === void 0 ? void 0 : _a.call(ReferralWindow, lang, 'dark');
    };
};
exports.useOpenReferralWidget = useOpenReferralWidget;
